import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppMenu from "./AppMenu";

export default function AppDrawer({ open, toggleDrawer, setOpen }) {
  return (
    <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
      <AppMenu setOpen={setOpen} />
    </Drawer>
  );
}
